import { CountryCode, EnvironmentEnum } from "@krea/shared/types/common";

interface IAppUrls {
  customer: string;
  lender: string;
  partner: string;
  admin: string;
}

type AppUrls = Record<CountryCode, Record<EnvironmentEnum, IAppUrls>>;

export const getAppUrls = (
  countryCode: CountryCode,
  environment: EnvironmentEnum,
) => {
  const appUrls: AppUrls = {
    [CountryCode.SE]: {
      [EnvironmentEnum.PRODUCTION]: {
        customer: "https://app.krea.se",
        lender: "https://lender.krea.se",
        partner: "https://partner.krea.se",
        admin: "https://admin.krea.se",
      },
      [EnvironmentEnum.STAGING]: {
        customer: "https://staging-app.krea.se",
        lender: "https://staging-lender.krea.se",
        partner: "https://staging-partner.krea.se",
        admin: "https://staging-admin.krea.se",
      },
      [EnvironmentEnum.DEVELOPMENT]: {
        customer: "http://localhost:3003",
        lender: "http://localhost:3000",
        partner: "http://localhost:3004",
        admin: "http://localhost:3005",
      },
      [EnvironmentEnum.TEST]: {
        customer: "https://test-app.krea.se",
        lender: "https://test-lender.krea.se",
        partner: "https://test-partner.krea.se",
        admin: "https://test-admin.krea.se",
      },
    },
    [CountryCode.FI]: {
      [EnvironmentEnum.PRODUCTION]: {
        customer: "https://app.kredita.fi",
        lender: "https://lender.krea.se",
        partner: "https://partner.kredita.fi",
        admin: "https://admin.krea.se",
      },
      [EnvironmentEnum.STAGING]: {
        customer: "https://staging-app.kredita.fi",
        lender: "https://staging-lender.krea.se",
        partner: "https://staging-partner.kredita.fi",
        admin: "https://staging-admin.krea.se",
      },
      [EnvironmentEnum.DEVELOPMENT]: {
        customer: "http://localhost:3003",
        lender: "http://localhost:3000",
        partner: "http://localhost:3004",
        admin: "http://localhost:3005",
      },
      [EnvironmentEnum.TEST]: {
        customer: "https://test-app.kredita.fi",
        lender: "https://test-lender.krea.se",
        partner: "https://test-partner.kredita.fi",
        admin: "https://test-admin.krea.se",
      },
    },
  };

  return appUrls[countryCode][environment];
};
